<template>
  <div class="free-audio-list">
    <div class="free-audio-item"
         v-for="(item, index) in list"
         :key="index"
    >
      <audio-player :item="item"
                    :loading="checkPlaying(item.id) && playerLoading"
                    :playing="checkPlaying(item.id)"
                    @click-icon="handlePlay"
                    @click-desc="handleShowPage"
      />
    </div>
  </div>
</template>

<script>
  import { decorator, before } from 'ym-reporter-vue';
  import { mapGetters } from 'vuex';
  import AudioPlayer from '@/pages/Audio/components/FreeAudioPlayer';
  import { getProductPath, projectJump } from '@/utils';
  import PlayerPlaylistStorageMixin from '@/mixins/player/playerPlaylistStorage';

  export default {
    name: 'FreeAudioList',
    mixins: [PlayerPlaylistStorageMixin],
    components: {
      AudioPlayer,
    },
    data() {
      return {
        isSetList: false,
      };
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
      type: {
        type: String,
        default: 'audio',
      },
    },
    computed: {
      ...mapGetters([
        'player',
      ]),
      playerLoading() {
        return this.player.getLoadingStatus() === 'loading';
      },
      recordName() {
        if (this.type === 'home') return 'MAIN_DAILY_AUDIO_PLAY_CLICK';
        return 'AUDIO_FREE_AUDIO_PLAY_CLICK';
      },
    },
    watch: {
      list() {
        this.isSetList = false;
      },
    },
    methods: {
      checkPlaying(id) {
        const { player } = this;
        const { playingId } = player;
        return playingId === id;
      },
      @decorator(before(function (item) {
        this.$reporter.report(this.recordName, item);
      }))
      handlePlay(current) {
        const { id } = current;
        current.disabled = true;

        const { player, list } = this;
        const { playingId } = player;
        if (!this.isSetList) {
          this.isSetList = true;
        }
        if (playingId === id) {
          player.pause();
          current.disabled = false;
          return;
        }
        this.setGlobalPlayerInfo(list, true, true, 'program');
        const index = player.getPlaylistIndexById(id);
        player.play(index);
        current.disabled = false;
      },
      handleShowPage(current) {
        const { path } = current;
        const { type, id } = path;
        const { player, list } = this;
        const { playingId } = player;
        if (playingId !== 0) {
          player.pause();
        }
        this.setGlobalPlayerInfo(list, true, true, 'program');
        const route = getProductPath(type, id);
        projectJump(route);
      },
    },
    created() {
      this.isSetList = false;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .free-audio-list {
    padding: @size-base 0 @size-large 0;
  }

  .free-audio-item {
    padding: 0 @size-base;
    &:not(:last-child) {
      margin-bottom: @size-base;
    }
  }
</style>
